module.exports = __webpack_public_path__ + "img/logo-ai.92b7fe47.svg";